import React, { useEffect, useRef } from "react";
import { getEstimaticsCurrentProjectStore } from "../../../data/DataStores";
import { useNavigate } from "react-router-dom";
import Analytics from "../../../utils/Analytics";
import { observer } from "mobx-react";
import { MeasurementPanel } from "../EstimateEngine/EstimateTable/Measurements";
import EngineUtils from "../../../shared/common/EngineUtils";
import { LassoSimpleButtonFull } from "../../../components/ui/utils/LassoButtons";
import { v4 as uuidv4 } from "uuid";
import { PostUploadCommands } from "../../../shared/common/Azure";
import { logDebug } from "../../../shared/common/logger";

// const MeasurementPanelContainer: React.FC<{ file: any }> = ({ file }) => {
// 	logDebug("MeasurementPanelContainer-file", file);
// 	return (
// 		<div>
// 			{/* <div>{file.source}</div> */}
// 			{file.postUploadResults &&
// 				file.postUploadResults.map((result: any, index: any) => {
// 					return (
// 						<div key={index}>
// 							{result.command !== PostUploadCommands.extractRoomNamesFromTic &&
// 							result.command !== PostUploadCommands.manuallyAddRoom ? (
// 								<>{result.command}</>
// 							) : (
// 								<div key={index}>
// 									{result?.results?.rooms?.map((room: any, index: number) => {
// 										// logDebug("MeasurementPanelContainer-room", room);
// 										const pageId = EngineUtils.createPageKey(file.uploadId, room.imageName, file.source);
// 										return (
// 											<div key={index}>
// 												{!(room.hasInteriorRepairWorksheetHeader || room.hasBathroomKitchen) ? null : (
// 													<div>
// 														<MeasurementPanel pageId={pageId} roomName={room.roomName} isWizard={true} />
// 													</div>
// 												)}
// 											</div>
// 										);
// 									})}
// 								</div>
// 							)}
// 						</div>
// 					);
// 				})}
// 		</div>
// 	);
// };

export const OneMeasurementCell: React.FC<{ name: string; measurement: string; value: string; onBlur: (newValue: string) => void }> = ({
	measurement,
	name,
	value,
	onBlur,
}) => {
	const inputRef = useRef<HTMLInputElement>(null);
	const [workValue, setWorkValue] = React.useState(value);
	const [hasFocus, setHasFocus] = React.useState(false);
	return (
		<div className="self-stretch h-20 w-[115px] flex-col justify-center items-start gap-2 flex">
			<div className="self-stretch h-7 px-3.5 justify-center items-start inline-flex">
				<div className="grow shrink basis-0 text-[#475466] text-xs font-normal font-['Hanken Grotesk'] leading-[14.40px]">
					{name}
				</div>
			</div>
			<div className="self-stretch justify-start items-center gap-2 inline-flex">
				<div className="grow shrink basis-0 flex-col justify-start items-start gap-0.5 inline-flex">
					<div className="self-stretch h-11 flex-col justify-start items-start gap-1.5 flex">
						<div className="self-stretch pl-3.5 pr-2 py-2.5 rounded-lg justify-start items-center gap-2 inline-flex">
							<div className="grow shrink basis-0 h-6 justify-start items-center gap-2 flex">
								{hasFocus && (
									<>
										<input
											ref={inputRef}
											type="number"
											className="text-[#101828] px-0.5 w-12 text-base font-normal font-['Hanken Grotesk'] leading-normal "
											value={workValue}
											onChange={(e) => setWorkValue(e.target.value)}
											onBlur={(e) => {
												onBlur(workValue);
												setHasFocus(false);
											}}
											onKeyDown={(e) => {
												if (e.key === "Enter") {
													inputRef.current?.blur();
												}
											}}
										/>
										{/* {measurement} */}
									</>
								)}
								{!hasFocus && (
									<div
										onClick={(e) => {
											e.stopPropagation();
											e.preventDefault();
											setHasFocus(true);
											setTimeout(() => {
												inputRef.current?.focus();
											}, 0);
										}}
										className="btn text-[#101828] pl-[2px] text-base font-normal font-['Hanken Grotesk'] leading-normal hover:border hover:pl-[1px] border-blue-800 no-break"
									>
										{value} {measurement}
									</div>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export const NewProjectWizardStep3: React.FC<{ onNext: (n: number) => void; onBack: () => void; onCancel: () => void }> = observer(
	({ onNext, onBack, onCancel }) => {
		const [roomNameCount, setRoomNameCount] = React.useState(0);
		const newProjectStore = getEstimaticsCurrentProjectStore();
		// logDebug('NewProjectWizardStep3', newProjectStore.uploadedFilesProperties);
		const lastUploadId = useRef("");
		const [showError, setShowError] = React.useState(false);
		const [showMeasurementSceeen, setShowMeasurementScreen] = React.useState(true);
		const navigate = useNavigate();
		async function uploadEstimate() {
			setShowError(false);
			const success = await newProjectStore.uploadEstimate(undefined, undefined, true);
			if (success) {
				// await SharedUtils.sleep(100);
				// onCancel();
				navigate(`/projects/${newProjectStore.estimaticsData.estimateId}`);
			} else {
				setShowError(true);
			}
		}
		useEffect(() => {
			if (!showMeasurementSceeen) {
				// avoid uploading the same estimate twice
				if (lastUploadId.current === newProjectStore.currentEstimateID) {
					return;
				}
				lastUploadId.current = newProjectStore.currentEstimateID;
				uploadEstimate();
			}
		}, [showMeasurementSceeen]);
		// let uniqueRooms = EngineUtils.getUniqueRooms(newProjectStore.uploadedFilesProperties);
		const uniqueRoomsWithName = newProjectStore.uploadedFilesProperties
			.map((file) => {
				if (
					(file.postUploadResults &&
						file.postUploadResults.length > 0 &&
						file.postUploadResults[0].command === PostUploadCommands.extractRoomNamesFromTic) ||
					file.postUploadResults[0].command === PostUploadCommands.manuallyAddRoom
				) {
					return file.postUploadResults[0].results.rooms.map((room: any) => {
						const shouldShow = room.hasInteriorRepairWorksheetHeader || room.hasBathroomKitchen;
						const pageId = EngineUtils.createPageKey(file.uploadId, room.imageName, file.source);
						return { name: room.roomName, file, pageId, shouldShow };
					});
				}
				return [];
			})
			.flat()
			.filter((r, i, a) => a.findIndex((rr) => rr.name === r.name) === i);
		// logDebug("NewProjectWizardStep3-roomNames", uniqueRoomsWithName, newProjectStore.uploadedFilesProperties);
		if (showMeasurementSceeen) {
			return (
				<div className="px-6 flex justify-between  flex-col h-full">
					<div className="mt-[34px] self-stretch  flex-col justify-start items-start gap-16 flex h-full overflow-y-auto scrollbar-thin ">
						<div>
							<div>Measurement Screen</div>
							<div>
								{uniqueRoomsWithName
									// .map((f) => f.file)
									.map((fileAndNameAndPageId, index) => {
										// logDebug("NewProjectWizardStep3-fileAndName", fileAndNameAndPageId, index);
										return (
											<div key={fileAndNameAndPageId.name} id={fileAndNameAndPageId.name}>
												{(fileAndNameAndPageId.file.postUploadResults[0].command ===
													PostUploadCommands.extractRoomNamesFromTic ||
													fileAndNameAndPageId.file.postUploadResults[0].command ===
														PostUploadCommands.manuallyAddRoom) &&
													fileAndNameAndPageId.shouldShow && (
														<MeasurementPanel
															pageId={fileAndNameAndPageId.pageId}
															roomName={fileAndNameAndPageId.name}
															isWizard={true}
														/>
														// <MeasurementPanelContainer file={fileAndNameAndPageId} />
													)}
											</div>
										);
									})}
								{/* {uniqueRooms.length > 0 &&
									uniqueRooms.map((room, index) => {
										return (
											<div key={index}>
												<MeasurementPanel pageId={room!.pageId} roomName={room!.roomname} isWizard={true} />
											</div>
										);
									})} */}
							</div>
						</div>
						<LassoSimpleButtonFull
							caption="Add Room"
							onClick={() => {
								newProjectStore.uploadedFilesProperties.push({
									destination: "",
									mime: "",
									uploadId: uuidv4(),
									source: "",
									postUploadResults: [
										{
											command: PostUploadCommands.manuallyAddRoom,
											results: {
												rooms: [
													{
														imageName: "",
														roomName: `Unnamed Room ${roomNameCount + 1}`,
														hasInteriorRepairWorksheetHeader: true,
													},
												],
											},
										},
									],
								});
								setRoomNameCount(roomNameCount + 1);
							}}
						/>
					</div>
					<div className="h-24 px-6 py-6 border-t border-gray-200 justify-between items-start w-full flex">
						<div
							className="w-24 px-[18px] py-2.5 bg-white rounded-lg border border-gray-200 justify-center items-center gap-2 flex btn "
							onClick={onBack}
						>
							<div className="justify-start items-center gap-2 flex ">
								<div className="text-slate-700 text-base font-semibold font-['Hanken Grotesk'] leading-normal select-none">
									Back
								</div>
							</div>
						</div>
						<div className=" items-center  flex">
							{
								<div
									className={` h-11 w-24 px-[18px] py-2.5  rounded-lg  border ${
										newProjectStore.nextDisabled === 0
											? "btn shadow bg-blue-900 border-blue-900 text-white"
											: "bg-gray-100 border-gray-200 text-gray-300"
									} justify-center items-center gap-2 flex `}
									onClick={() => {
										if (newProjectStore.nextDisabled === 0) {
											Analytics.Instance.track("NewProjectWizardStep3Next", {
												notesCount: newProjectStore.estimaticsData.notes.length,
												linksCount: newProjectStore.estimaticsData.links.length,
												filesCount: newProjectStore.estimaticsData.files.filter((f) => !f.deleted).length,
												deletedFilesCount: newProjectStore.estimaticsData.files.filter((f) => f.deleted).length,
											});
											setShowMeasurementScreen(false);

											// onNext(3);
										}
									}}
								>
									<div className="justify-start items-center gap-2 flex  ">
										<div className=" text-base font-semibold font-['Hanken Grotesk'] leading-normal select-none">
											Finish
										</div>
									</div>
								</div>
							}
						</div>
					</div>
				</div>
			);
		} else {
			return (
				<div className="flex w-full h-full items-center justify-center select-none">
					<div className="flex flex-col w-full justify-center items-center">
						{!showError && (
							<div>
								<div>Creating Estimate...</div>
								<img className="w-64 h-64" src="/assets/ui/loading-building.gif" />
							</div>
						)}
						{showError && (
							<div className="w-[616px] h-[366px] px-[88px] flex-col justify-center items-center gap-[23px] inline-flex">
								<div className="w-32 h-32 p-[5.82px] justify-center items-center inline-flex">
									<img
										src="/assets/ui/sign-no.svg"
										className="w-[116.36px] h-[116.36px] relative flex-col justify-start items-start flex"
									/>
								</div>
								<div className="text-gray-900 text-xl font-semibold font-['Hanken Grotesk'] leading-7">
									Server Error: Failed to Create New Project
								</div>
								<div className="self-stretch text-center">
									<span className="text-gray-900 text-xs font-normal font-['Hanken Grotesk'] leading-none">
										An unexpected server error occurred while attempting to create your new estimate. Please try again.
										<br />
									</span>
									<span className="text-gray-900 text-xs font-normal font-['Hanken Grotesk'] leading-none">
										Important: To avoid losing your entered data, please do not close this page. If the issue persists
										after multiple attempts, please contact our support team for assistance.
									</span>
								</div>
								<div
									className="px-4 py-2.5 bg-blue-900 rounded-lg shadow border border-blue-900 justify-start items-center gap-2 inline-flex btn"
									onClick={uploadEstimate}
								>
									<div className="justify-start items-center gap-2 flex">
										<div className="text-white text-sm font-semibold font-['Hanken Grotesk'] leading-tight">
											Try Again
										</div>
									</div>
								</div>
							</div>
						)}
					</div>
				</div>
			);
		}
	},
);
